import React from 'react';
import { styled } from '@mui/system';
import Typography from '@mui/material/Typography';
import Tags from 'components/Tags';

const ChosenFiltersWrapper = styled('div')(({ theme }) => ({
  marginBottom: 40,
  [theme.breakpoints.down('md')]: {
    marginBottom: 20
  }
}));

const ChosenFilters = ({
  chosenCategories,
  chosenTags,
  chosenSkills,
  filters,
  handleChangeCategories,
  handleChangeTags,
  handleChangeSkills,
  personal,
  handleClearPersonal,
  t
}) => {
  return (
    <ChosenFiltersWrapper>
      {chosenCategories.length > 0 && (
        <>
          <Typography variant="caption">{t('ChosenCategories')}</Typography>
          <Tags
            list={chosenCategories}
            checked={filters?.category_ids || []}
            onDelete={handleChangeCategories}
          />
        </>
      )}

      {chosenTags.length > 0 && (
        <>
          <Typography variant="caption">{t('ChosenTags')}</Typography>
          <Tags list={chosenTags} checked={filters?.tag_ids || []} onDelete={handleChangeTags} />
        </>
      )}

      {personal && (
        <>
          {chosenTags.length === 0 && <Typography variant="caption">{t('ChosenTags')}</Typography>}
          <Tags
            list={[{ title: t('Personal') }]}
            checked={true}
            onDelete={() => {
              handleClearPersonal();
            }}
          />
        </>
      )}

      {chosenSkills.length > 0 && (
        <>
          <Typography variant="caption">{t('ChosenSkills')}</Typography>
          <Tags
            list={chosenSkills}
            checked={filters?.skill_ids || []}
            onDelete={handleChangeSkills}
          />
        </>
      )}
    </ChosenFiltersWrapper>
  );
};

export default ChosenFilters;
